module.exports = __webpack_public_path__ + "img/paci_en_7.3e0a1f49.png";